import { load } from 'worker-timers-broker';
import { createLoadWorkerTimers } from './factories/load-worker-timers';
import { worker } from './worker/worker';
/*
 * @todo Explicitly referencing the barrel file seems to be necessary when enabling the
 * isolatedModules compiler option.
 */
export * from './types/index';
const loadWorkerTimers = createLoadWorkerTimers(load, worker);
export const clearInterval = (timerId) => loadWorkerTimers().clearInterval(timerId);
export const clearTimeout = (timerId) => loadWorkerTimers().clearTimeout(timerId);
export const setInterval = (func, delay) => loadWorkerTimers().setInterval(func, delay);
export const setTimeout = (func, delay) => loadWorkerTimers().setTimeout(func, delay);
//# sourceMappingURL=module.js.map